import { Col, Form, notification, Row } from 'antd';
import { memo, useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';

import ButtonWrap from '@/components/ButtonWrap';
import FormItemWrap from '@/components/FormItemWrap';
import InputOnlyNumber from '@/components/InputOnlyNumber';
import InputWrap from '@/components/InputWrap';
import { pattern } from '@/constants/validate';
import { appRoutes } from '@/router/routes';
import floorService from '@/services/floor.service';
import { handleMessageError } from '@/util/handleMessageError';
import { RequestFloorDTO } from '@/dto/responseDto/request-floor.dto';

const FormData = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const {
        control,
        reset,
        setValue,
        formState: { errors },
        handleSubmit,
        clearErrors,
    } = useForm();

    const { data: floorItem } = useQuery(['floor', id], () => floorService.detail(String(id)), {
        enabled: !!id,
        keepPreviousData: false,
        onError: (error: any) => {
            handleMessageError(error);
        },
    });

    const { mutate: mutateCreate, isLoading: isLoadingCreate } = useMutation(
        (e: RequestFloorDTO) => floorService.create(e),
        {
            onSuccess: (data: any) => {
                onGoList();
                queryClient.removeQueries('floor');
                notification.success({
                    message: 'THÊM TẦNG THÀNH CÔNG',
                });
            },
            onError: (error: any) => {
                handleMessageError(error);
            },
        },
    );

    const { mutate: mutateUpdate, isLoading: isLoadingUpdate } = useMutation(
        (e: RequestFloorDTO) => floorService.update(String(id), e),
        {
            onSuccess: (data: any) => {
                onGoList();
                queryClient.removeQueries('floor');
                notification.success({
                    message: 'CẬP NHẬT THÀNH CÔNG',
                });
            },
            onError: (error: any) => {
                handleMessageError(error);
            },
        },
    );

    const onGoList = () => {
        reset({});
        navigate(`${appRoutes.ADMIN.ROOM.FLOOR}`, { replace: true });
    };

    const onSubmit = (data: any) => {
        const body: RequestFloorDTO = {
            name: data.name,
            sortOrder: Number(data.sortOrder),
        };
        id ? mutateUpdate(body) : mutateCreate(body);
    };

    useEffect(() => {
        if (floorItem) {
            reset({
                name: floorItem?.data?.name,
                sortOrder: floorItem?.data?.sortOrder,
            });
        }
    }, [floorItem, reset]);

    return (
        <Form labelCol={{ span: 6 }} onFinish={handleSubmit(onSubmit)}>
            <Col span={24} xl={{ span: 16, offset: 4 }} xxl={{ span: 12, offset: 6 }}>
                {/* {id && <FormItemWrap label={t('floor:t13')}>{id}</FormItemWrap>} */}
                <FormItemWrap label={'TÊN TẦNG'} required validateStatus={errors?.name ? 'error' : ''}>
                    <Controller
                        name="name"
                        control={control}
                        rules={{ required: true, maxLength: 10 }}
                        render={({ field }) => <InputWrap field={field} />}
                    />
                </FormItemWrap>
                <FormItemWrap label={'Sắp xếp'} required validateStatus={errors?.sortOrder ? 'error' : ''}>
                    <Controller
                        name="sortOrder"
                        control={control}
                        rules={{ required: true, pattern: pattern.inputNumber }}
                        render={({ field }) => <InputOnlyNumber maxLength={1} field={field} />}
                    />
                </FormItemWrap>
                <Row justify="end" gutter={16}>
                    <Col>
                        <ButtonWrap
                            isLoading={isLoadingCreate || isLoadingUpdate}
                            htmlType="submit"
                            text={!id ? 'THÊM MỚI' : 'CẬP NHẬT'}
                            type="primary"
                            width="140px"
                        />
                    </Col>
                </Row>
            </Col>
        </Form>
    );
};

export default memo(FormData);
